var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGutterReplacementActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 39,
    viewBox: "0 0 52 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2988_1918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1258 31.3584H22.1345V34.7227H25.1258V31.3584Z",
    fill: "#4AAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3658 31.3584H27.3756V34.7227H30.3658V31.3584Z",
    fill: "#4AAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3658 25.75H27.3756V29.1132H30.3658V25.75Z",
    fill: "#4AAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1258 25.75H22.1345V29.1132H25.1258V25.75Z",
    fill: "#4AAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7501 14.7936V16.4741L26.2506 4.19499L2.75122 16.4741V14.7925L26.211 2.53369L49.7501 14.7936Z",
    fill: "#4AAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7115 19.0133V24.9775L27.3756 13.3056V7.37988L49.7115 19.0133Z",
    fill: "#4AAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1257 7.34033V13.3056L2.78979 24.9775V19.0122L25.1257 7.34033Z",
    fill: "#4AAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9999 13.4326V20.1847L51.9614 20.1644V28.6869L26.2506 15.2521L0.539912 28.6869V20.1644L0.501343 20.1847V13.4337L26.2089 0L51.9999 13.4326ZM49.7501 16.4741V14.7935L26.211 2.53365L2.75122 14.7924V16.4741L26.2506 4.19495L49.7501 16.4741ZM49.7115 24.9773V19.0131L27.3756 7.37965V13.3054L49.7115 24.9773ZM25.1257 13.3054V7.3401L2.78979 19.012V24.9773L25.1257 13.3054Z",
    fill: "#10260F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6157 23.5054V36.9679H19.8846V23.5054H32.6157ZM30.3659 34.7229V31.3586H27.3757V34.7229H30.3659ZM30.3659 29.1136V25.7504H27.3757V29.1136H30.3659ZM25.1258 34.7229V31.3586H22.1345V34.7229H25.1258ZM25.1258 29.1136V25.7504H22.1345V29.1136H25.1258Z",
    fill: "#10260F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1641 24.5635L12.7557 28.2838H11.2751C10.988 34.2416 6.04038 38.9999 0 38.9999V36.7549C4.79974 36.7549 8.73488 33.0026 9.02093 28.2838H7.57244L10.1641 24.5635Z",
    fill: "#10260F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2988_1918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 39,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGutterReplacementActive);
export default __webpack_public_path__ + "static/media/gutter-replacement-active.e86fc7a67c8104b65187f1f7aed6e7f1.svg";
export { ForwardRef as ReactComponent };